import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface QueryParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序字段 累计外设计入次数：access_count（默认），计算机名：computor_name，所属分组；group_name，登记用户名：user_mark，终端状态：device_status） */
  sort_key: string
  /** 排序,true-正序，false-倒序 */
  asc: boolean
  /** 查询关键词 */
  search_word: string
  /** 设备状态 1：启动，2：禁用，3：全部（默认） */
  peripheral_status: number
  /** 终端状态 1：在线，2：离线，3：全部（默认） */
  device_status: number
  /** 时间范围 1：全部 ，2：最近24小时 （默认），3：最近7天 ，4：近一个月 */
  time_range: number
}

export interface TerminalItem {
  /** 终端ID */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 所属分组 */
  group_name: string
  /** 登记用户名 */
  user_mark: string
  /** 内网ip地址 */
  client_ip: string
  /** 外网ip地址 */
  system_ip: string
  /** mac地址 */
  mac: string
  /** 终端状态 1：在线，2：离线 */
  device_status: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  /** 累计外设接入次数 */
  access_count: number
  /** 触发策略 */
  strategy_name?: string
}

@Injectable()
export default class TerminalViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getTerminalList (data: QueryParams) {
    return this.http.post<{
      /** 终端视图信息列表 */
      list: TerminalItem[]
      /** 总数 */
      total: number
    }>('/peripheralcontrol/view/terminal/get', data)
  }
}
